
import { Component, Prop, Watch } from 'vue-property-decorator';

import Booking from '@/views/Booking.vue';
import { SuppliersApi } from '@/api/SuppliersApi';

import { SupplierResponse } from '@/interfaces/Suppliers';
import md5 from 'md5';
import { ActivityResponse } from '@/interfaces/Activities';
import { mapState } from 'vuex';

@Component
export default class Form extends Booking {
   @Prop({ type: [Object] }) model!: SupplierResponse;

   @Prop({ type: [Number, String], default: 0 }) id!: number | string;

   form: SupplierResponse | null = null;

   mounted() {
      this.onChangeModel();
      this.$root.$on('header:save', this.submit);
      this.$root.$on('header:copy', this.duplicate);
      this.$root.$on('header:remove', this.archive);
      this.$root.$on('header:restore', this.unarchive);
   }

   beforeDestroy() {
      this.$root.$off('header:save', this.submit);
      this.$root.$off('header:copy', this.duplicate);
      this.$root.$off('header:remove', this.archive);
      this.$root.$off('header:restore', this.unarchive);
   }

   createHash(form: any = {}): string {
      return md5(
         JSON.stringify({
            ...this.model,
            ...form,
            o_average_gp: null,
            o_minimum_gp: null,
            o_maximum_gp: null,
            o_new_average_gp: null,
            o_new_minimum_gp: null,
            o_new_maximum_gp: null,
            o_gp_table: null,
            o_transfer_cost_table: null,
            o_activity_cost_table: null,
            o_activity_price_table: null,
         })
      );
   }

   submit() {
      if (!this.form) return;

      this.$store.commit('showLoading');
      SuppliersApi.update(this.model.o_id, this.form)
         .then(() => {
            this.$bvModal.msgBoxOk('Saved successfully');
            return this.$emit('get-order');
         })
         .finally(() => {
            this.$store.commit('hideLoading');
         });
   }

   duplicate() {
      if (!window.confirm('Do you want to create a copy of this object?')) {
         return;
      }

      this.$store.commit('showLoading');
      SuppliersApi.duplicate(this.model.o_id)
         .then(({ id }: any) => {
            this.$router.push({ name: 'settings:supplier.edit', params: { id } });
         })
         .finally(() => {
            this.$store.commit('hideLoading');
         });
   }

   archive() {
      this.$store.commit('showLoading');
      SuppliersApi.archive(this.model.o_id)
         .then(() => this.$emit('get-order'))
         .finally(() => {
            this.$store.commit('hideLoading');
         });
   }

   unarchive() {
      this.$store.commit('showLoading');
      SuppliersApi.unarchive(this.model.o_id)
         .then(() => this.$emit('get-order'))
         .finally(() => {
            this.$store.commit('hideLoading');
         });
   }

   @Watch('model', { deep: true })
   onChangeModel() {
      this.form = { ...this.model };

      this.$store.commit('setItems', {
         name: 'beforeunload',
         value: this.createHash(),
      });

      this.$store.commit('setItems', {
         name: 'loadBeforeunload',
         value: this.createHash(),
      });
   }

   @Watch('form', { deep: true })
   onChangeForm(n: ActivityResponse) {
      this.$store.commit('setItems', {
         name: 'beforeunload',
         value: this.createHash(n),
      });
   }
}
